import { render, staticRenderFns } from "./QuestionsView.vue?vue&type=template&id=6f919cdb&scoped=true&"
import script from "./QuestionsView.vue?vue&type=script&lang=js&"
export * from "./QuestionsView.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsView.vue?vue&type=style&index=0&id=6f919cdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f919cdb",
  null
  
)

export default component.exports